import { makeRequest, Service, identify } from 'utils/http';

export async function getWorkspaceAPI() {
  return makeRequest(Service.getWorkspace(await identify()));
}
